"use strict";
exports.__esModule = true;
exports.Objects = void 0;
var camelize_1 = require("./camelize");
var difference_1 = require("./difference");
var fromPairs_1 = require("./fromPairs");
var isEmpty_1 = require("./isEmpty");
var isEqual_1 = require("./isEqual");
var path_1 = require("./path");
var propertyOf_1 = require("./propertyOf");
var setInPath_1 = require("./setInPath");
var toPairs_1 = require("./toPairs");
exports.Objects = {
    camelize: camelize_1.camelize,
    difference: difference_1.difference,
    fromPairs: fromPairs_1.fromPairs,
    isEmpty: isEmpty_1.isEmpty,
    isEqual: isEqual_1.isEqual,
    path: path_1.path,
    propertyOf: propertyOf_1.propertyOf,
    setInPath: setInPath_1.setInPath,
    toPairs: toPairs_1.toPairs
};
//# sourceMappingURL=index.js.map